import { SharedAngular } from '@Client/@types/sharedAngular';
import angular, {
  ILocationService,
  ITimeoutService,
  IWindowService
} from 'angular';
import IModelerWorkflowDetail from '@Shared.Angular/@types/core/contracts/queryModel/modeler/modelerWorkflowDetail';

class RunnerPrintFlowModelSchemaController {
  public static $inject = [
    'flowinglyDiagramService',
    'goService',
    '$timeout',
    '$window',
    'documentApiService',
    '$location',
    'appInsightsService'
  ];

  constructor(
    private flowinglyDiagramService: SharedAngular.FlowinglyDiagramService,
    private goService: GoJS,
    private $timeout: ITimeoutService,
    private $window: IWindowService,
    private documentApiService: SharedAngular.DocumentApiService,
    private $location: ILocationService,
    private appInsightsService: SharedAngular.AppInsightsService
  ) {
    this.printTraceId = `printMap-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 8)}`;
    this.trace('printMap:init', {
      route: this.$location.path(),
      queryId: String(this.$location.search().id || '')
    });
    this.appInsightsService.startEventTimer?.('processMapRenderForPrint');

    this.displayFlowModel();
  }

  private flowModel: IModelerWorkflowDetail;
  private diagram: any;
  private printTraceId: string;

  private trace(message: string, properties?: Record<string, unknown>) {
    this.appInsightsService.trackTrace?.(message, {
      printTraceId: this.printTraceId,
      ...properties
    });
  }

  private displayFlowModel() {
    this.onAnimationFinished = this.onAnimationFinished.bind(this);

    const flowModelSchemaId = this.$location.search().id;

    this.trace('printMap:fetch:start', { flowModelSchemaId });

    try {
      this.documentApiService
        .getFlowModelSchema(flowModelSchemaId)
        .then((flowModel) => {
          this.flowModel = flowModel;
          // For printing we always want to layout like it's a Process Map
          (this.flowModel as any).isProcessMap = true;

          return this.$timeout(() => {
            try {
              this.diagram = this.flowinglyDiagramService.generateProcessModel({
                flow: flowModel,
                applyAvatar: false,
                modelCustomArgs: {
                  scrollMode: this.goService.Diagram.DocumentScroll
                },
                allowSelect: true,
                dynamicInitialHeight: this.$window.innerHeight
              });

              if (typeof this.diagram !== 'undefined') {
                this.trace('printMap:diagram:generate:ok', {
                  nodeCount: this.diagram?.model?.nodeDataArray?.length ?? 0,
                  linkCount: this.diagram?.model?.linkDataArray?.length ?? 0
                });

                this.diagram.addDiagramListener(
                  'AnimationFinished',
                  this.onAnimationFinished
                );
                (window as any).diagram = this.diagram;
                this.trace('printMap:diagram:listener-attached');
              } else {
                this.trace('printMap:diagram:generate:undefined');
              }
            } catch (e) {
              this.trace('printMap:diagram:generate:exception', {
                message: e?.message,
                stack: e?.stack
              });
              throw e;
            }
          });
        })
        .catch((err) => {
          this.trace('printMap:fetch:rejection', {
            message: err?.message || err?.statusText || err?.status,
            stack: err?.stack
          });
          throw err;
        });
    } catch (e) {
      this.trace('printMap:fetch:exception', {
        message: e?.message,
        stack: e?.stack
      });
      throw e;
    }
  }

  private onAnimationFinished(e) {
    this.trace('printMap:animation:finished');

    this.diagram.links.each((link) => {
      link.invalidateRoute();
    });
    this.$timeout(() => {
      //record elapsed seconds from init → handoff to HiQPDF
      this.appInsightsService.trackMetricIfTimerExist?.(
        'processMapRenderForPrint',
        {
          printTraceId: this.printTraceId
        }
      );

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (typeof hiqPdfConverter_startConversion === 'function') {
        this.trace('printMap:hiqpdf:invoke');
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        hiqPdfConverter_startConversion();
        this.trace('printMap:hiqpdf:invoked');
      } else {
        this.trace('printMap:hiqpdf:not-found');
      }
    }, 1000);
  }
}
angular
  .module('flowingly.runner.print')
  .controller(
    'runnerPrintFlowModelSchemaController',
    RunnerPrintFlowModelSchemaController
  );
